import { MdOutlineLocalFireDepartment, MdOutlineCheckCircle } from "react-icons/md";
import { formatNumber } from "./crmHelpers";

/*
  Progresso do dia.

  É o único indicador da tela que SOBE quando a pessoa trabalha. Todo o resto
  — filas, contas a contatar, receita em jogo — recalcula e continua cheio
  depois de uma manhã inteira de ligações, porque a base é maior que o dia.
  Sem este bloco, a tela de trabalho dá a impressão permanente de que nada
  andou.

  A meta é uma referência, não uma cobrança: serve para dar forma à barra. Um
  número absoluto sem escala ("7 contatos") não diz se o dia foi bom.
*/

const META_DIARIA = 15;

const DayProgress = ({ today }) => {
  const contatos = today?.contactsLogged || 0;
  const tarefas = today?.tasksCompleted || 0;
  const feito = contatos + tarefas;
  const progresso = Math.min((feito / META_DIARIA) * 100, 100);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex items-baseline justify-between gap-3">
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">
          Seu dia
        </p>
        <p className="text-[11px] text-slate-400">
          meta de referência: {META_DIARIA}
        </p>
      </div>

      <p className="mt-1 flex items-baseline gap-1.5">
        <span className="text-3xl font-bold leading-none text-slate-900">
          {formatNumber(feito)}
        </span>
        <span className="text-sm text-slate-500">ações registradas</span>
      </p>

      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-slate-100">
        <div
          className={`h-full rounded-full transition-all duration-500 ${
            progresso >= 100 ? "bg-emerald-500" : "bg-pink-500"
          }`}
          style={{ width: `${Math.max(progresso, 2)}%` }}
        />
      </div>

      <div className="mt-2.5 flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-slate-600">
        <span className="flex items-center gap-1.5">
          <MdOutlineLocalFireDepartment size={13} className="text-pink-500" />
          {formatNumber(contatos)} contato(s)
        </span>
        <span className="flex items-center gap-1.5">
          <MdOutlineCheckCircle size={13} className="text-emerald-500" />
          {formatNumber(tarefas)} tarefa(s) concluída(s)
        </span>
      </div>
    </div>
  );
};

export default DayProgress;
